const state =  {
    token : '',
    userInfo: null
}

export default state